import { render, staticRenderFns } from "./lio-logo.vue?vue&type=template&id=041671d8&"
import script from "./lio-logo.vue?vue&type=script&lang=js&"
export * from "./lio-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports